var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showLoading)?_c('div',{staticClass:"view-mask view-mask-flex"},[_c('div',{staticClass:"view-loading"},[_c('img',{staticClass:"view-loading-img",attrs:{"src":"https://cdn.kuaidi100.com/images/smart/order/loading.gif"}}),_c('p',{staticClass:"view-loading-text"},[_vm._v(_vm._s(_vm.text))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }